import React from 'react';
import styled from 'styled-components';
import Button from '../Button';
import PText from '../PText';
import SectionTitle from '../SectionTitle';
import AboutImg from "../../assets/images/about-sec-imgs.jpg";

const AboutSectionStyles = styled.div`

  @media only screen and (max-width: 375px) {
    padding: 1rem 0;
  }

  @media only screen and (max-width: 320px) {
    padding: 1rem 0;
  }

  padding: 2rem 0;

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    padding: 10px;

  }

  .aboutSection__right {

  }

  .aboutImg {
    border-radius: 5%;
    border: 2px solid white;
    width: 90%;
  }

  .aboutSection__left,
  .aboutSection__right {
    flex: 1;
  }

  .section-title {
    text-align: left;
  }

  .para {
    margin-top: 2rem;
    margin-left: 0;
  }

  .aboutSection__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    margin-top: 2rem;
  }

  @media only screen and (max-width: 950px) {
    .aboutSection__left {
      flex: 4;
    }

    .aboutSection__right {
      flex: 3;

    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      text-align: center;

    }

    .aboutSection__left,
    .aboutSection__right {
      width: 100%;
    }

    //Animation
    .aboutSection__right {
      margin-top: 3rem;
    }


    .section-title {
      text-align: center;
    }

    .para {
      margin: 0 auto;
      margin-top: 2rem;
    }

    .aboutSection__buttons {
      flex-direction: column;
      //gap: 0;
      .button-wrapper,
      a {
        width: 100%;
        text-align: center;
      }
    }
  }
`;
export default function AboutSection() {
    return (
        <AboutSectionStyles>
            <div className="container">
                <div className="aboutSection__left">
                    <SectionTitle
                        subheading="Let me introduce myself"
                        heading="About_Me"
                    />
                    <PText>
                        I am a result-oriented front-end
                        developer with experience in creating
                        Landing pages and SPA using React(JS/
                        TS),Redux(Toolkit), Unit-Testing, HTML5, CSS3.
                        Now I am improving my skills in this
                        direction and expanding them with
                        the help of new technologies. And I
                        also have an interest in learning React Native. My free time is devoted to solving the roadmap
                        , according to which I study code and improve my
                        English. I always keep the phrase in my head - "You need to work not for 12 hours, but with your
                        head!"
                    </PText>
                    <div className="aboutSection__buttons">
                        <Button btnText="Works" btnLink="/projects"/>
                        <Button btnText="Read More" btnLink="/about" outline/>
                    </div>
                </div>
                <div className="aboutSection__right">
                    <img src={AboutImg} className="aboutImg" alt="hero__about"/>
                </div>
            </div>
        </AboutSectionStyles>
    );
}
